// Calculates the correct number of bulls that are shown using the filters applied
export function CalculateSelectedBullCount(data) {
    if (!Array.isArray(data) || data.length === 0) return 0;

    // Remove null/undefined entries
    const cleaned = data.filter(d => d != null);

    // Count entries that are not the average row (average row has RegId == null)
    const avgRowCount = cleaned.reduce((acc, cur) => acc + ((cur && cur.RegId == null) ? 1 : 0), 0);

    return Math.max(0, cleaned.length - avgRowCount);
}